import authenticate from "@/auth/authenticate";
import hasUltimatePermission from "@/auth/hasUltimatePermission";


export default [
  {
    path: "/ultimate",
    component: () => import("@/views/global/Index"),
    meta: { layout: "auth" },
    beforeEnter: authenticate,

    children: [
      {
        path: "",
        name: "ultimate.index",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/admin/Index"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "api-keys",
        name: "ultimate.api-keys",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/ApiKeys"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "changelogs",
        name: "ultimate.changelogs",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/Changelogs"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "platforms",
        name: "ultimate.platforms",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/Platforms"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "users",
        name: "ultimate.users",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/Users"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "companies",
        name: "ultimate.companies",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/Companies"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "companies/:id",
        name: "ultimate.companies.management",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/CompaniesManagement"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "invoices",
        name: "ultimate.invoices",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/Invoices"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "cash-control",
        name: "ultimate.cash-control",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/CashControl"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "merch-products",
        name: "ultimate.merch-products",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/components/admin/registrations/MerchProducts"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "features",
        name: "ultimate.features",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/Features"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "feature-audiences",
        name: "ultimate.featureAudiences",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/FeatureAudiences"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "messager",
        name: "ultimate.messager",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/Messager"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "campaigns",
        name: "ultimate.campaigns",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/Campaigns.vue"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "campaigns/:id",
        name: "ultimate.campaigns.detail",
        meta: { layout: "VerticalUltimate", hiddenAppBar: false },
        component: () => import("@/views/ultimate/CampaignDetail.vue"),
        beforeEnter: hasUltimatePermission,
      },
      {
        path: "*",
        redirect: "/",
      },
    ],
  },
];
